import React, { useState, useRef, useEffect } from "react";
import "./ModalAddPrivacyPolicy.css";
import { Button, Modal, Input, InputNumber, Checkbox, Image } from "antd";
import { addIcon, editIcon, termsAndUse } from "../../assets";
import { useSelector } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";
import { callApi } from "../../api/apiCaller";
import routes from "../../api/routes";
import { upload } from "../../helper/helper";

const ModalAddPrivacyPolicy = ({
  setShowModal,
  showModal,
  item,
  setIsLoading,
  addProduct,
  setAddProduct,
}) => {
  // data is stored as an { en, es, ... } translation object on the backend.
  // TinyMCE's initialValue needs a plain HTML string, so pick one language to show/edit.
  const displayText = (val) =>
    typeof val === "string"
      ? val
      : val?.en || val?.es || Object.values(val || {})[0] || "";

  const [description, setDescription] = useState(item?.description || "");
  const [isUpdating, setIsUpdating] = useState(false);
  console.log("item id", item._id);
  const fileInputRef = useRef(null);
  const editorRef = useRef(null);

  const createProduct = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Mirrors updateProduct below: disable the button for the duration of the request so
    // it cannot be pressed twice.
    setIsUpdating(true);

    let getRes = (res) => {
      setIsUpdating(false);
      setShowModal(false);
      setAddProduct(false);
    };

    let body = {
      description: editorRef.current.getContent(),
    };

    callApi(
      "POST",
      routes.createPrivacyPolicy,
      body,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        setIsUpdating(false);
      }
    );
  };

  const updateProduct = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsUpdating(true);

    let getRes = (res) => {
      setIsUpdating(false);
      setShowModal(false);
    };

    let body = {
      data: editorRef.current.getContent(),
    };
    console.log("item", item._id);
    callApi(
      "PATCH",
      `${routes.updatePrivacyPolicy}/${item?._id}`,
      body,
      setIsLoading,
      getRes,
      (error) => {
        console.log("error", error);
        setIsUpdating(false);
      }
    );
  };

  const handleEditorChange = (content, editor) => {
    setDescription(content);
  };

  return (
    <div className="add-product-modal-main-container">
      <div className="add-product-modal-container">
        <div style={{ marginTop: "5rem" }}></div>
        <div>
          <h3>Content</h3>
          <Editor
            apiKey="kttjxe20gth0u5wh3mfo9b9ix7o7o7dvr1zdsamvp09xfycq"
            onInit={(evt, editor) => {
              editorRef.current = editor;
            }}
            initialValue={displayText(item?.data)}
            onEditorChange={handleEditorChange}
            init={{
              plugins: "image link",
              file_picker_types: "file image media",
              relative_urls: false,
              remove_script_host: false,
            }}
          />
        </div>

        <div className="modal-btn-container"></div>
        <div style={{ marginBottom: "3rem" }}>
          <Button
            onClick={() => {
              setShowModal(false);
            }}
            type="default"
            danger
          >
            Cancel
          </Button>
          {addProduct ? (
            <Button
              onClick={createProduct}
              style={{ marginLeft: "2rem" }}
              loading={isUpdating}
              disabled={isUpdating}
              type="primary"
            >
              Add
            </Button>
          ) : (
            <Button
              onClick={updateProduct}
              style={{ marginLeft: "2rem" }}
              loading={isUpdating}
              disabled={isUpdating}
              type="primary"
            >
              Update
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModalAddPrivacyPolicy;
